import axios from 'src/api/Api';
import { put } from 'redux-saga/effects';
import {
    EDIT_PRICE_OVERRIDE_SUCCESS,
    EDIT_PRICE_OVERRIDE_FAILURE,
} from '../actions';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export function* editPriceOverrideData(action) {
    const baseSiteId = localStorage.getItem('baseSiteId');
    const url = `/occ/v2/${baseSiteId}/priceOverride/edit`;

    try {
        const response = yield axios.put(url, action.payload);
        yield put({ type: EDIT_PRICE_OVERRIDE_SUCCESS, data: response.data });
    } catch (error) {
        yield put({
            type: EDIT_PRICE_OVERRIDE_FAILURE,
            data: errorHandler(error),
        });
        logUiErrorToBackend('editPriceOverrideData', error);
    }
}
